import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

// Must match erp-backend's CompaniesController::DUPLICABLE_SECTIONS.
const DUPLICABLE_SECTIONS = [
  { key: 'offices', label: 'Oficinas' },
  { key: 'templates', label: 'Plantillas de impresión' },
  { key: 'roles', label: 'Roles y permisos' },
  { key: 'pay_methods', label: 'Métodos de pago' },
  { key: 'measurements', label: 'Unidades de medida' },
  { key: 'product_types', label: 'Tipos de producto' },
  { key: 'categories', label: 'Familias' },
];

@Component({
  selector: 'app-company-duplicate-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './company-duplicate-form.component.html',
})
export class CompanyDuplicateFormComponent {
  @Input() id: number = 0;
  @Input() sourceName = '';
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public sections = DUPLICABLE_SECTIONS;

  public saveForm: FormGroup = new FormGroup({});

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      cif: new FormControl('', [Validators.required, Validators.maxLength(9), Validators.minLength(9)]),
      email: new FormControl(null, [Validators.email]),
      code: new FormControl(null),
      is_active: new FormControl(false),
      include: new FormGroup(Object.fromEntries(this.sections.map(s => [s.key, new FormControl(true)]))),
    });
  }

  get includeGroup(): FormGroup {
    return this.saveForm.get('include') as FormGroup;
  }

  acceptFormFunction() {
    this.saveEntity();
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  saveEntity() {
    if (!this.saveForm.valid) {
      this.saveForm.markAllAsTouched();
      Utils.notification.alert('Debe completar todos los campos obligatorios');
      return;
    }

    const { include, ...fields } = this.saveForm.value;
    const body = {
      ...fields,
      include: Object.keys(include).filter(key => include[key]),
    };

    this.saving.set(true);
    this.cdr.detectChanges();

    this.apiService.post(`${Urls.urls.companies}/${this.id}/duplicate`, body).subscribe({
      next: (response: any) => {
        Utils.notification.success(response?.message || 'Empresa duplicada correctamente');
        this.acceptFunction.emit(response);
        this.closeFormFunction();
      },
      error: (error: any) => {
        this.saving.set(false);
        this.cdr.detectChanges();
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al duplicar la empresa');
      },
    });
  }
}
